<div class="panel">
  <mat-toolbar color="accent">
    <mat-toolbar-row>
      Layers
      <span class="toolbar-spacer"></span>
      <button mat-icon-button (click)="closeSidePanel()" class="btn">
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>

  <div class="panel-content">
    <h2>Map Layers</h2>
    <section class="section">
      @for (layer of mapLayers; track layer) {
        <div>
          @if (layer.toggleable.get()) {
            <mat-checkbox [checked]="!layer.hidden.get()"
              (change)="changeMapLayer($event, layer)">
              {{ layer.name }}
            </mat-checkbox>
          }
        </div>
      }
    </section>
    <section class="section">
      @for (resultSourceItem of resultSourceArray; track resultSourceItem) {
        <div>
          <mat-checkbox [checked]="resultSourceItem.selected" (change)="changeResultLayer($event, resultSourceItem)">
            {{ resultSourceItem.name }}
            @if ((resultSourceItem.totalCount > 0)) {
              <span class="layerCount">
                {{resultSourceItem.totalCount}}
              </span>
            }
          </mat-checkbox>
        </div>
      }
    </section>

    <label id="basemap-radio-group">
      <h2>Basemaps</h2>
    </label>
    <mat-radio-group aria-labelledby="basemap-radio-group" class="basemap-radio-group"
      [(ngModel)]="currentBaseLayerOption" (change)="baseLayerChange($event)">
      @for (option of baseLayerOptions; track option) {
        <mat-radio-button class="example-radio-button" [value]="option">
          {{option.name}}
        </mat-radio-button>
      }
    </mat-radio-group>
  </div>
</div>